<div class="breadcrumb-container">
    <div class="row">
        <!-- Left Column: 2 Rows of Cards -->
        <div class="col-12 col-md-8 col-lg-9 d-flex">
            <div class="row g-2 flex-grow-1 custom-first-row ">
                <!-- Top Row: 3 Cards -->
                <div class="col-md-4 d-flex">
                    <mat-card class="contact-card bg-light-blue flex-fill d-flex align-items-center">
                        <div class="d-flex w-100 p-3 yammer-content">

                            <a href="https://web.yammer.com/main/org/optum.com/groups/eyJfdHlwZSI6Ikdyb3VwIiwiaWQiOiIxMTc2MzM4OTIzNTIifQ/new"
                                target="_blank">


                                <img src="/assets/images/yammer.jpg" alt="Yammer Icon" class="yammer-icon me-3">
                                <span class="card-title mb-1 text-primary">Join us on Viva Engage</span>
                            </a>
                        </div>
                    </mat-card>

                </div>
                <div class="col-md-4 d-flex">
                    <mat-card class="contact-card bg-light-green flex-fill">
                        <mat-card-header class="card-header">
                            <mat-card-title style="color: #013b71;">Contact Via Email</mat-card-title>
                        </mat-card-header>
                        <mat-card-content>
                            <div class="row">
                                <div class="col-md-5 support-icon">
                                    <a href="mailto:techopshub_support@uhg.com?subject={{loggedUser}} looking for Support"
                                        title="Support">
                                        <img src="/assets/images/Support.jpg" alt="Support Icon" class="yammer-icon">
                                        <br>
                                        <span class="bottom-text">Support</span> </a>

                                </div>
                                <div class="col-md-3" style="margin-left: 10px;">

                                    <a href="mailto:techopshub_support@uhg.com?subject={{loggedUser}} submitted the feedback"
                                        title="Feedback">
                                        <img src="/assets/images/Feedback.jpg" alt="Feedback Icon" class="yammer-icon">
                                        <br>
                                        <span class="bottom-text">Feedback</span>
                                    </a>
                                </div>
                            </div>
                        </mat-card-content>
                    </mat-card>
                </div>

                <div class="col-md-4 d-flex">
                    <mat-card class="contact-card bg-light-yellow flex-fill d-flex align-items-center">
                        <mat-card-header class="card-header" style="margin-right: 5rem;">

                            <mat-card-title> <a href="https://uhctops.ideas.aha.io/portal_session/new"
                                    target="_blank"><img src="/assets/images/idea.jpg" alt="Yammer Icon"
                                        class="yammer-icon" style="margin-right: 0.5rem;">
                                    <span style="color: #013b71;">Submit an Idea</span> </a></mat-card-title>
                        </mat-card-header>
                        <mat-card-content>
                            <a href="https://uhctops.ideas.aha.io/portal_session/new" target="_blank"><img
                                    src="/assets/images/aha.jpg" alt="Yammer Icon" class="yammer-icon me-3"></a>
                        </mat-card-content>
                    </mat-card>
                </div>
                <!-- Second Row: 2 Cards -->
                <div class="col-md-4 d-flex custom-height-card">
                    <mat-card class="contact-card bg-light-purple flex-fill">
                        <mat-card-header class="card-header">
                            <mat-card-title style="margin-right: 4rem;"> <img src="/assets/images/teams.jpg"
                                    alt="Yammer Icon" class="yammer-icon"> <span style="color: #013b71;"> Contact Via
                                    Teams </span></mat-card-title>
                        </mat-card-header>
                        <mat-card-content class="teams-contact">
                            <ul>
                                <ng-container *ngFor="let item of pageData">
                                    <li *ngIf="item.category === 'Contact Via Teams'"><a href="{{item.content}}"
                                            target="_blank">{{item.title}}</a></li>

                                </ng-container>
                            </ul>
                        </mat-card-content>
                    </mat-card>
                </div>

                <div class="col-md-8 d-flex">
                    <mat-card class="contact-card bg-light-orange flex-fill">
                        <mat-card-header class="card-header" >
                            <mat-card-title style="color: #013b71;">Upcoming Events</mat-card-title>
                        </mat-card-header>
                        <mat-card-content>
                            <div class="row event-row">
                                <!-- Calendar Icon -->
                                <div class="col-md-2 text-center">
                                    <img src="/assets/images/calender.png" alt="Calendar Icon" class="yammer-icon">
                                </div>

                                <!-- Event Content -->
                                <div class="col-md-10">

                                    <!-- If both categories are empty -->
                                    <ng-container *ngIf="!hasUpcomingEvents() && !hasUpcomingDemo(); else eventsExist">

                                        <div class="text-muted mt-3 me-5 text-center">No Upcoming Events</div>
                                    </ng-container>

                                    <!-- Attend Office Hours Row -->
                                    <ng-template #eventsExist>
                                        <div class="d-flex mb-3 office-hrs-section">
                                            <ng-container *ngIf="hasUpcomingEvents();">
                                                <div class="label lebel-text">Attend Office Hours</div>
                                                <div class="flex-grow-1 d-flex">
                                                    <div style="border-left: 3px solid #E1BB91; margin-right: 5px;">
                                                    </div>
                                                    <div style="background-color: #FDE9D2; padding: 5px;">
                                                        <ng-container *ngFor="let item of pageData">
                                                            <div class="event-time"
                                                                *ngIf="item.category === 'Upcoming Events'">
                                                                <a href="{{item.content}}" target="_blank"
                                                                    rel="noopener noreferrer">
                                                                    {{item.title}}
                                                                </a>
                                                            </div>
                                                        </ng-container>
                                                    </div>
                                                </div>
                                             </ng-container>
                                        </div>




                                        <!-- Demo Row -->
                                        <div class="d-flex office-hrs-section">
                                            <ng-container *ngIf="hasUpcomingDemo();">
                                                <div class="label lebel-text-demo">Demo</div>
                                                <div class="flex-grow-1 d-flex">
                                                    <div style="border-left: 3px solid #ADC1BE; margin-right: 5px;">
                                                    </div>
                                                    <div style="background-color: #DCE9E7; padding: 5px;">
                                                        <ng-container *ngFor="let item of pageData">
                                                            <div class="event-time"
                                                                *ngIf="item.category === 'Upcoming Events Demo'">
                                                                <a href="{{item.content}}" target="_blank"
                                                                    rel="noopener noreferrer">
                                                                    {{item.title}}
                                                                </a>
                                                            </div>
                                                        </ng-container>
                                                    </div>
                                                </div>
                                             </ng-container>
                                        </div>


                                    </ng-template>


                                </div>
                            </div>
                        </mat-card-content>
                    </mat-card>
                </div>
            </div>
        </div>

        <!-- Right Column: Points of Contact -->
        <div class="col-12 col-md-4 col-lg-3 d-flex" style="margin-left: -10px;">
            <mat-card class="contact-card bg-light-red flex-fill d-flex flex-column">
                <mat-card-header class="mb-3 ms-2">
                    <mat-card-title> <img src="/assets/images/pointofcontact.jpg" alt="Contact Icon" class="yammer-icon"
                            style="margin-right: 0.5rem;">
                        <span style="color: #013b71;">Points of Contact</span> </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div class="pointofcontact-text ms-3" style="text-align: start;" *ngFor="let item of pageData">
                        <ng-container *ngIf="item.category === 'Point of Contact'">
                            <p> <strong [innerHTML]="item.content | safeHtml"></strong> <br>
                                <span class="contact-title"> ({{item.title}})</span>
                            </p>
                        </ng-container>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>

<div *ngIf="!pageData" class="portfolio-totalApp-loader-margin">
    <app-loader class="loader-inside-card"></app-loader>
</div>